module.exports = __webpack_public_path__ + "img/img-qcode.9056394a.png";